import { render, staticRenderFns } from "./SettlementDetailsContainer.vue?vue&type=template&id=9ec9a1da&scoped=true&"
import script from "./SettlementDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./SettlementDetailsContainer.vue?vue&type=script&lang=js&"
import style0 from "./SettlementDetailsContainer.vue?vue&type=style&index=0&id=9ec9a1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec9a1da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VDialog,VFlex,VForm,VImg,VLayout,VRadio,VRadioGroup,VTextField})
